import { GetNameDefForClass } from "./GetNameDefForClass";

export function GetNameDefForObj(dbObj) {
  var aClass = dbObj.GetParentClass();
  return GetNameDefForClass(aClass);
}
